var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-img',{attrs:{"src":_vm.postImage,"aspect-ratio":"1.7778"}}),_c('div',{staticClass:"font-weight-bold body-1 mt-2"},[_vm._v(" "+_vm._s(_vm.postBody)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }